import { ChevronLeft, ChevronRight, ExternalLink, X } from 'lucide-react';

import { Button } from '@/common/components/ui/button';
import { SheetHeader, SheetTitle } from '@/common/components/ui/sheet';

interface DrawerHeaderProps {
  title: string;
  externalLink: {
    label: string;
    path: string;
  };
  onClose: () => void;
  onNavigatePrevious: () => void;
  onNavigateNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
}

export const DrawerHeader = ({
  title,
  externalLink,
  onClose,
  onNavigatePrevious,
  onNavigateNext,
  hasPrevious,
  hasNext,
}: DrawerHeaderProps) => {
  return (
    <SheetHeader className="p-4 pb-0 bg-primary-foreground">
      <div className="flex items-center justify-between mb-4">
        <Button
          variant="default"
          size="icon"
          onClick={onClose}
          aria-label="Close"
          className="bg-terra-cotta-100 hover:bg-terra-cotta-200"
        >
          <X className="h-4 w-4 stroke-primary" />
        </Button>

        <div className="flex gap-2">
          <Button
            variant="default"
            size="icon"
            onClick={onNavigatePrevious}
            disabled={!hasPrevious}
            aria-label="Previous billing"
            className="bg-terra-cotta-100 hover:bg-terra-cotta-200"
          >
            <ChevronLeft className="h-4 w-4 stroke-primary" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onNavigateNext}
            disabled={!hasNext}
            aria-label="Next billing"
            className="bg-terra-cotta-100 hover:bg-terra-cotta-200"
          >
            <ChevronRight className="h-4 w-4 stroke-primary" />
          </Button>
        </div>
      </div>

      <div className="pb-4">
        <SheetTitle className="text-2xl font-bold text-foreground mb-2">
          {title}
        </SheetTitle>
        <a
          className="flex items-center gap-2 text-sm font-md cursor-pointer"
          href={externalLink.path}
          target="_blank"
        >
          {externalLink.label}
          <ExternalLink className="stroke-2 w-4" />
        </a>
      </div>
    </SheetHeader>
  );
};
